import React, { useState } from 'react'
import TicketOption from './ticket-options'

const TicketOptionsContainer = ({
  gaImage,
  gppImage,
  gaDescription,
  gpDescription
}) => {
  const [gaToggle, setGaToggle] = useState(true)
  const [gppToggle, setGppToggle] = useState(false)

  const toggleGpp = () => {
    if (!gppToggle) {
      setGppToggle(true)
      setGaToggle(false)
    }
  }

  const toggleGa = () => {
    if (!gaToggle) {
      setGaToggle(true)
      setGppToggle(false)
    }
  }

  return (
    <div>
      <TicketOption
        preview={gaToggle}
        name={'Shedd Tickets'}
        description={gaDescription}
        link={'/tickets'}
        linkText={'Continue to Select Date'}
        productCardPhoto={gaImage}
        onClick={toggleGa}
      />
      <TicketOption
        preview={gppToggle}
        name={'Groups and Field Trips'}
        description={gpDescription}
        link={'/group-tickets'}
        linkText={'Book A Group Visit'}
        productCardPhoto={gppImage}
        onClick={toggleGpp}
        previewText={'Reserve your 15+ person visit!'}
      />
    </div>
  )
}
export default TicketOptionsContainer
